
































































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import Vue from 'vue';
import { fetchProveedores } from './fetchProveedores';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { GridApi } from 'ag-grid-community';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarProveedor extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ required: true }) usuarioActivo: any;
  @Prop({
    default: () => ({ id: 0, nombre: '', estado: EstadoEntidad.Activo }),
  })
  accion!: any;
  data: any = {};
  monedas: Array<object> = [];
  esProducto: {}[] = [];
  esContrato: {}[] = [];
  esEstrategico: {}[] = [];
  estados: string[] = [];

  handleState() {
    this.desactivado = this.formFields.estado.value === 'ACTIVO' ? false : true;
  }

  rules = {
    required: (value: any) => !!value || 'Required.',
    counter: (value: any) => value.length <= 15 || 'Máximo 15 caracteres',
    soloLetras: (value: any) => {
      return value.match(/^[a-zA-Z]*$/) || 'Solo se permiten letras';
    },
    email: (value: any) => {
      if (value != '') {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Email Inválido';
      }
    },
  };

  desactivado: boolean = false;
  async validateValue() {
    if (this.edited.estado === 'INACTIVO') {
      this.desactivado = true;
    }
  }

  async getFilters() {
    this.loadingService.showLoading();
    let self = this;
    return fetchProveedores({}, 'conectaMantenedorProveedores/get_filters')
      .then((data: any) => {
        const {
          MENSAJE_RESPUESTA,
          CODIGO_RESPUESTA,
          MONEDAS,
          ES_PRODUCTO,
          ES_CONTRATO,
          ES_ESTRATEGICO,
          ESTADOS,
        } = data.data;

        if (CODIGO_RESPUESTA == '1') {
          self.monedas = MONEDAS;
          self.esProducto = ES_PRODUCTO;
          self.esContrato = ES_CONTRATO;
          self.esEstrategico = ES_ESTRATEGICO;
          self.estados = ESTADOS;
        } else {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Hubo un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
      })
      .finally(() => {
        self.loadingService.hideLoading();
        return null;
      });
  }

  async mounted() {
    await this.getFilters();
    await this.validateValue();
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  formFields: {
    internacional: any;
    rut: any;
    razon: any;
    direccion: any;
    pais: any;
    telefono: any;
    contacto: any;
    email: any;
    condicion: any;
    moneda: any;
    es_producto?: Record<string, string>;
    es_contrato?: Record<string, string>;
    provee_tipo_producto?: Record<string, string>;
    es_estrategico?: Record<string, string>;
    estado: any;
  } = {
    internacional: {
      label: 'Internacional',
      value: this.edited.internacional,
    },
    rut: {
      label: 'RUT',
      value: this.edited.proveedorrut,
    },
    razon: {
      label: 'Razón Social',
      value: this.edited.proveedorrazon,
    },
    direccion: {
      label: 'Dirección',
      value: this.edited.proveedordireccion,
    },
    pais: {
      label: 'País',
      value: this.edited.proveedorpais,
    },
    telefono: {
      label: 'Teléfono',
      value: this.edited.proveedortel
        ? Number(this.edited.proveedortel.slice(1))
        : '',
    },
    contacto: {
      label: 'Contacto',
      value: this.edited.proveedorcontacto,
    },
    email: {
      label: 'Email',
      value: this.edited.proveedoremail,
    },
    es_producto: {
      label: '¿Es Producto o Servicio?',
      value: this.edited.val_producto,
    },
    es_contrato: {
      label: '¿Es Contrato?',
      value: this.edited.val_contrato,
    },
    provee_tipo_producto: {
      label: 'Tipo de Producto o Servicio',
      value: this.edited.provee_tipo_producto,
    },
    es_estrategico: {
      label: '¿Es Estratégico o Común?',
      value: this.edited.val_estrategico,
    },
    condicion: {
      label: 'Condición',
      value: this.edited.proveedorcondicion,
    },
    moneda: {
      label: 'Moneda',
      value: this.edited.isomoneda,
    },
    estado: {
      label: 'Estado',
      value: this.edited.estado,
    },
  };

  //abstract
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.TablaMantenedorProveedores;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  validarEmail() {
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    return emailRegex.test(this.datoEditado.email);
  }

  datoEditado: any = {};

  grabarEdicion() {
    this.datoEditado.rut = this.formFields.rut.value.toUpperCase();
    this.datoEditado.razon = this.formFields.razon.value.toUpperCase();
    this.datoEditado.direccion = this.formFields.direccion.value.toUpperCase();
    this.datoEditado.pais = this.formFields.pais.value.toUpperCase();

    this.datoEditado.contacto = this.formFields.contacto.value.toUpperCase();
    this.datoEditado.email = this.formFields.email.value.toUpperCase();
    this.datoEditado.condicion = this.formFields.condicion.value.toUpperCase();
    this.datoEditado.moneda = this.formFields.moneda.value;
    this.datoEditado.estado = this.formFields.estado.value == 'INACTIVO';

    if (this.formFields.telefono.value.length > 15) {
      this.$snotify.error(
        'El campo Teléfono solo permite un máximo de 15 caracteres',
        {
          timeout: 3000,
        }
      );
      return;
    }
    this.datoEditado.telefono =
      this.formFields.telefono.value.length > 0
        ? '+' + this.formFields.telefono.value
        : '';

    if (this.datoEditado.email != '' && !this.validarEmail()) {
      this.$snotify.error('Por favor verifique que el email sea valido', {
        timeout: 3000,
      });
      return;
    }
    this.datoEditado.cambioEstado =
      this.edited.estado !== this.formFields.estado.value ? true : false;
    this.editar();
  }

  async editar() {
    let self = this;
    return fetchProveedores(
      {
        rut: this.datoEditado.rut,
        razon: this.datoEditado.razon,
        direccion: this.datoEditado.direccion,
        pais: this.datoEditado.pais,
        telefono: this.datoEditado.telefono,
        contacto: this.datoEditado.contacto,
        email: this.datoEditado.email,
        codicion: this.datoEditado.condicion,
        moneda: this.datoEditado.moneda,
        usuarioId: this.usuarioActivo.id,
        usuarioRut: this.usuarioActivo.rut,
        estadoInicial: this.datoEditado.estadoInicial,
        estado: this.datoEditado.estado,
        cambioEstado: this.datoEditado.cambioEstado,
        es_producto: this.formFields.es_producto.value,
        es_contrato: this.formFields.es_contrato.value,
        provee_tipo_producto: this.formFields.provee_tipo_producto.value,
        es_estrategico: this.formFields.es_estrategico.value,
      },
      'conectaMantenedorProveedores/editar'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.closeModal(false);
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
          return null;
        }); */
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;

    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
}
